<template>
  <div class="card card-deal text-center" ref="pane">
    <div class="card-header text-white" :class="[`bg-${color}`]">
      <i
        class="icon-deal fa mb-2"
        :class="[`fa-${icon}`]"
      ></i>
      <h2 class="p-0 m-0">{{ title }}</h2>
    </div>
    <div class="card-body">

      <div class="subtitle font-italic mb-3 d-flex align-items-center">
        <div class="text-center w-100">
          <slot name="subtitle"></slot>
        </div>
      </div>

      <div class="mb-3">
        <v-button
          :text="buttonText"
          :style-type="color"
          :rounded="true"
          @click="$emit('research-type-selected', researchType)"
          size="lg"
        />
      </div>

      <h4 v-if="!hidePrice">vanaf &euro; {{ price }},-</h4>
    </div>
    <div class="card-footer" v-if="!collapsed">
      <v-button
        size="sm"
        :icon="showInfo ? 'times': 'info-circle'"
        style-type="secondary"
        :text="showInfo ? 'phrase.less_info': 'phrase.more_info'"
        @click="showInfo = !showInfo"
      />

      <v-collapse-transition>
        <div class="card-body text-left" v-if="showInfo">
          <slot name="content"></slot>
        </div>
      </v-collapse-transition>
    </div>
    <div class="footer" v-else>
      <div class="card-body text-left">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

export default {
  name: 'RegisterCommercialCard',
  components: {
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  props: {
    buttonText: {
      type: String,
      default() {
        return 'word.register';
      },
    },
    collapsed: {
      type: Boolean,
      default() {
        return false;
      },
    },
    color: {
      type: String,
    },
    hidePrice: {
      type: Boolean,
      default() {
        return false;
      },
    },
    icon: {
      type: String,
      default() {
        return 'question';
      },
    },
    price: {
      type: Number,
    },
    researchType: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
};
</script>

<style scoped>
.card-deal .subtitle {
  min-height: 70px;
}
</style>
